module.exports = __webpack_public_path__ + "img/reports.3bff8868.svg";